import { derived, get } from "svelte/store";
import { v1 as uuidv1 } from "uuid";
export const DEFAULT_VOTE_TYPES = [
    { type: "1", emoji: "🗨", toolTip: "I want to talk about this one.", maxVotes: 3 },
    { type: "2", emoji: "⭐", toolTip: "Interesting!", maxVotes: 1 },
    { type: "3", emoji: "❓", toolTip: "I have questions about this topic.", maxVotes: 1 },
];
export class VoteType {
    emoji;
    toolTip;
    maxVotes;
    type;
    constructor(emoji, toolTip, maxVotes) {
        this.emoji = emoji;
        this.toolTip = toolTip;
        this.maxVotes = maxVotes;
        this.type = uuidv1();
    }
}
export class Board {
    workspace;
    name;
    constructor(workspace) {
        this.workspace = workspace;
        this.name = derived(workspace.state, state => state.name);
    }
    hash() {
        return this.workspace.workspaceHash;
    }
    close() {
        this.workspace.leaveWorkspace();
    }
    state() {
        return get(this.workspace.state);
    }
    requestChanges(deltas) {
        console.log("REQUESTING CHANGES: ", deltas);
        this.workspace.requestChanges(deltas);
    }
    participants() {
        return this.workspace.participants;
    }
    async commitChanges() {
        this.workspace.commitChanges();
    }
}
export class ArchivedBoard {
    state;
    constructor(state) {
        this.state = state;
    }
}
export class Group {
    name;
    id;
    constructor(name) {
        this.name = name;
        this.id = Date.now();
    }
}
